import { useQuery } from "@tanstack/react-query";
import { fetchUnlinkedProjects } from "../services/projectsServices";

export const useUnlinkedProjects = () => {
  const { data: unlinkedProjects, isLoading, isError } = useQuery({
      queryKey: ["fetchUnlinkedProjects"],
      queryFn: fetchUnlinkedProjects,
  });
  return { unlinkedProjects, isLoading, isError };
};